import BaseApi from './BaseApi'

class FinancialServicesApi extends BaseApi {
  get financialServicesUrl () {
    return 'financialServices'
  }

  fetchingFinancialServices (financialServices) {
    return this.getJson(this.financialServicesUrl, financialServices)
  }
}
export default FinancialServicesApi

